/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { FC, useEffect, useState } from 'react';
import Notifications from '../../common/notification';
import { IoIosLogOut, IoMdLogOut } from 'react-icons/io';
import { authenticationService } from '../../../service/authentication';
import CustomToast from '../../../widgets/toaster';
import { userService } from '../../../service/userService';
import { handleLogOut as handleLogOutTimer  } from "../../../utils/oathUtils";
import { CgProfile } from "react-icons/cg";
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface PageHeaderProps {
  pageHeader: string;
  pageDescription?: string;
}

const PageHeader: FC<PageHeaderProps> = ({ pageHeader, pageDescription }) => {
  const [userDetails, setUserDetails] = useState<Array<any>>([]);
  const [userName, setUserName] = useState("")
  const [role, setRole] = useState("")
  const [remainingTime, setRemainingTime] = useState(20 * 60); // 20 minutes in seconds
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [authToken , setAuthToken] = useState("")
  const [authUserID , setAuthUserID] = useState("")
  const [userId, setUserId] = useState("");
  const [notificationCount, setNotificationCount] = useState(0)
  const [username, setUsername] = useState('');
  const [profileDropShow, setProfileDropShow] = useState(false)
  const navigate = useNavigate();

  useEffect(() => {
    var storedData = localStorage.getItem('userDetails');
    if(storedData) {
      var storedObject = JSON.parse(storedData);
      setUserDetails(storedObject || '')
      setUserName(storedObject[0]?.first_name + " " + storedObject[0]?.last_name);
      setAuthToken(storedObject[0].x_auth_token)
      setAuthUserID(storedObject[0].x_userid)
      setUserId(storedObject[0].id)
      getPermissionByRole(storedObject[0]?.role_master_id)
      listNotificationCount(storedObject[0].id);
      setUsername(storedObject[0].user_id)
    }
  }, [])

  const [isActive, setIsActive] = useState(true);
  const getPermissionByRole = async (role : number) => {
    try {
      const response = await userService.getPermissionByRole(role);
      if(response.status && response.statusCode === 200){
        setRole(response.data.title)
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
  if (!userId) return; // Don't run if userId is not available
  let intervalId: NodeJS.Timeout;
  const fetchNotifications = async () => {
    try {
      await listNotificationCount(userId);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  // Initial call
  fetchNotifications();

  // Set up interval for subsequent calls
  intervalId = setInterval(fetchNotifications, 90000); // 90 seconds

  // Cleanup function
  return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [userId]);

  // updated session logout function
  useEffect(() => {
  let inactivityTimeout : any;

  const resetTimeout = () => {
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(() => {
      setIsActive(false);
      handleLogOutTimer()
    }, 20 * 60 * 1000); // 20 minutes
  };

  const handleActivity = () => {
    if (!isActive) {
      setIsActive(true);
      setRemainingTime(20 * 60); // Reset the timer on activity
      resetTimeout();
    } else {
      setRemainingTime(20 * 60); // Reset the timer on activity
      resetTimeout();
    }
  };

  const updateRemainingTime = () => {
    setRemainingTime((prevTime) => Math.max(0, prevTime - 1));
  };

  resetTimeout();

  const intervalId = setInterval(updateRemainingTime, 1000);

  window.addEventListener('click', handleActivity);
  window.addEventListener('keypress', handleActivity);

  return () => {
    clearInterval(intervalId);
    window.addEventListener('click', handleActivity);
    window.removeEventListener('keypress', handleActivity);
    clearTimeout(inactivityTimeout);
  };
  }, [isActive]);

  const formattedTime = `${String(Math.floor(remainingTime / 60)).padStart(2, '0')}:${String(remainingTime % 60).padStart(2, '0')}`;

  const handleLogOut =  async () => {
    try {
      const response = await authenticationService.LogoutApi(userId, authToken, authUserID);
      if (response.status && response.statusCode === 200) {
        setToastType("success")
        setToastMessage(response.message)
        localStorage.removeItem('userDetails');
        window.location.replace(`/`);
      } else {
        setToastType("error");
        setToastMessage(response.message);
      }
      setShowToast(true)
    } catch (error) {
      console.error("Error signing in:", error);
    }
  }

  const listNotificationCount = async (id: string) => {
    try {
      const response = await authenticationService.listNotificationCount(id);
      if (response.status && response.statusCode === 200) {
        setNotificationCount(response.totalElements);
      } else {
        setNotificationCount(0);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  const handleProfileClick = () => {
    navigate(`/resetPassword?username=${username}`);
  };
  const { t } = useTranslation();
  return (
    <div 
    className='areaManagementHead d-flex align-items-center justify-content-between px-4'
    style={{ height: '60px', position: 'sticky', top: '50px', zIndex: 999, background: '#fff' }}
    >
    <CustomToast
    show={showToast}
    onClose={() => setShowToast(false)}
    delay={5000}
    message={toastMessage}
    toastType={toastType}
    />  
        <div className='px-2 pt-1'>
        <p className='headText1 mx-2 m-0 d-flex align-items-center' style={{ fontSize: '20px', height: '100%' }}>{pageHeader}</p>
        <p className='mx-2 m-0 d-flex align-items-center text-sm' >{pageDescription}</p>
        </div>
        <div className='d-flex pt-2'>
            <div className='boldText3 m-0'style={{ cursor: 'pointer', marginRight: '25px', marginTop: '25px' }} >
                <div style={{ position: 'relative', display: 'inline-block', marginTop: '10px' }}>
                  <CgProfile
                    id="dropdown-basic"
                    style={{ cursor: 'pointer', marginRight: '10px' }}
                    size={24}
                    onClick={() => setProfileDropShow(!profileDropShow)}
                  />
                  {profileDropShow && (
                    <Dropdown.Menu show style={{ position: 'absolute', top: '100%', right: 0, margin: "12px" }}>
                      <Dropdown.Item onClick={handleProfileClick} >{t('mediaPowder.header.changePassword')}</Dropdown.Item>
                    </Dropdown.Menu>
                  )}
                </div>
            </div>
            <div className='me-2' style={{ marginTop: '10px' }}>
                <p className='boldText3 m-0'>{userName} [ {role} ]</p>
                <p className='sessionLogoutText'>{t('mediaPowder.header.sessionLogout')} <span className='sessionLogoutTime'>{formattedTime}</span></p>
            </div>
            <div style={{paddingTop : "26px", marginRight: '21px'}}>
              <Notifications notificationCount={notificationCount} />
            </div>
            <div>
              <button onClick={() => handleLogOut()} className='logoutBtn' style={{ marginRight: '11px', marginTop: '26px' }}></button>
            </div>
        </div>
    </div>
  )
}

export default PageHeader